import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { DashboardData } from "@/data/dashboard";

interface DashboardHeaderProps {
  data: DashboardData | undefined;
}

function getTimeOfDayGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

export function DashboardHeader({ data }: DashboardHeaderProps) {
  const greeting = getTimeOfDayGreeting();
  const firstName = data?.profile?.full_name?.split(' ')[0];

  return (
    <div className="flex-1">
      <h1 className="text-2xl md:text-3xl font-bold">
        {greeting}{firstName ? `, ${firstName}` : ''}
      </h1>
      <p className="text-sm text-muted-foreground mt-2">
        Let's make your next closing fund your next wave of marketing.
      </p>
      
      {/* Stats row */}
      <div className="flex flex-wrap items-center gap-3 mt-4 text-sm">
        {data?.membership.is_founder && (
          <Badge variant="secondary" className="bg-gradient-to-r from-amber-500 to-orange-500 text-white">
            <Sparkles className="h-3 w-3 mr-1" />
            Circle Founder
          </Badge>
        )}
        {data?.membership.is_pro && !data?.membership.is_founder && (
          <Badge variant="default">Circle Pro</Badge>
        )}
        {!data?.membership.is_pro && !data?.membership.is_founder && (
          <Badge variant="secondary">Free Plan</Badge>
        )}
        <span className="text-muted-foreground">•</span>
        <span className="text-muted-foreground">
          {data?.favorites?.length || 0} tools in shortlist
        </span>
        <span className="text-muted-foreground">•</span>
        <span className="text-muted-foreground">
          {data?.usageStats?.dailyCount || 0}/{data?.usageStats?.dailyLimit || 5} AskCircle messages today
        </span>
        {data?.techStackSummary?.owned_count > 0 && (
          <>
            <span className="text-muted-foreground">•</span>
            <span className="text-muted-foreground">
              {data.techStackSummary.owned_count} tools owned
            </span>
          </>
        )}
      </div>
    </div>
  );
}
